import React from "react";
import PromptModal from "src/components/ConfirmationModal/PromptModalV2";
import { IApplicationAlert } from "src/store/models/application.model";
import { formatDate } from "src/views/CampaignDetail/utils";
import * as S from "../../../../../constants/StringConstants";

interface AppAlertModalProps {
  open: boolean;
  alerts: IApplicationAlert[];
  onClose: () => void;
}

const AppAlertModal: React.FC<AppAlertModalProps> = ({ open, alerts, onClose }) => {
  if (!open) return null;

  return (
    <PromptModal title={S.APP_ALERTS_POP_UP_TITLE} open={open} confirmText="Ok" onConfirm={onClose}>
      {alerts.map(alert => (
        <div key={alert.applicationAlertHeaderId}>
          <br />
          <h5>
            Added {formatDate(alert.createdOn)} by {alert.createdBy}
          </h5>
          <hr />
          <p style={{ fontSize: "16px" }}>{alert.alertText}</p>
          <br />
        </div>
      ))}
    </PromptModal>
  );
};

export default AppAlertModal;
